<template>
  <div class="cont" id="appointments">
    <el-row>
      <el-col class="workingArea">
        <div
          class="card"
          id="card"
          ref="card"
          style="overflow: hidden !important;padding-bottom:20px"
        >
        <div class="container-Agenda">
          <div class="containerInfo">
            <div class="titleContainer">
              <h1>AGENDA DE CITAS</h1>
            </div>
            <div class="dateContainer">
              <h4> {{ $dateString(selectedDateStr) }}</h4>
            </div>
          </div>
          <div class="socialSwitch">
            <el-switch
              v-model="showSocial"
              active-text="Agenda Médica"
              inactive-text="Agenda Social"
              @change="changedMonth"
              v-if="role === 'TS' || role === 'FD'"
            />
          </div>
        </div>
        <div class="opcionesFiltradas">
          <div class = "botones" v-if="!showSocial">
            <div class="block">
              <span>Trabajador Social</span>
              <el-select v-model="trabajadorSocial" @change="handlerTs(trabajadorSocial)">
                <el-option
                  v-for="item in trabajadoresSociales"
                  :key="item.id"
                  :label="item.firstName + ' ' + item.lastName"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-button
              style="
                background-color: #6a41bdca;
                color: #ffffff;
                border-radius: 5px;
                font-size: 14px;
                margin-top: 17px;
                margin-left: 15px;
                height: 41px;"
                size="mini"
                @click="handlerTs('ALL')"
            >
              Mostrar Todos
            </el-button>
            <div
              class="block"
              style="
                display: flex;
                align-items: center;
                margin-top: 16px;
              "
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="Imprimir Agenda Actual"
                placement="top-start"
              >
                <el-button
                  icon="el-icon-printer"
                  style="
                    background-color: #6a41bdca;
                    color: #ffffff;
                    border-radius: 5px;
                    font-size: 16px;
                  "
                  @click="modalprintSocial = true;"
                />
              </el-tooltip>
            </div>
          </div>
          <div class="botones" v-if="showSocial">
            <div class="block">
              <span>
                Primera vez
              </span>
              <el-cascader
                placeholder="Seleccionar"
                :show-all-levels="false"
                v-model="valuePrimeraVez"
                :options="opciones"
                :props="{ expandTrigger: 'hover' }"
                @change="handlerPrimeraVez(valuePrimeraVez)"
              />
            </div>
            <div class="block">
              <span>
                Subsecuente
              </span>
              <el-cascader
                placeholder="Seleccionar"
                :show-all-levels="false"
                v-model="valueSubsecuente"
                :options="opciones"
                :props="{ expandTrigger: 'hover' }"
                @change="handleCommandEsp(valueSubsecuente)"
              />
            </div>
            <div class="block">
              <span>
                Post Operatoria
              </span>
              <el-cascader
                placeholder="Seleccionar"
                :show-all-levels="false"
                v-model="valueOperatoria"
                :options="opciones"
                :props="{ expandTrigger: 'hover' }"
                @change="handlerOperatoria(valueOperatoria)"
              />
            </div>
            <div class="block">
              <span>
                Emergencia
              </span>
              <el-cascader
                placeholder="Seleccionar"
                :show-all-levels="false"
                v-model="valueUrgencia"
                :options="opciones"
                :props="{ expandTrigger: 'hover' }"
                @change="handlerEmergencia(valueUrgencia)"
              />
            </div>
            <div class="block">
              <span>
                Estudios gabinete
              </span>
              <el-dropdown
                trigger="click"
                @command="handleCommandGab"
              >
                <el-button>
                  {{ filterTextGab }}
                  <i class="el-icon-arrow-down el-icon--right"/>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="'ALL'">
                    Mostrar todo
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="gabinete in gabineteProcedimientos"
                    :key="gabinete.value"
                    :command="gabinete.value"
                  >
                    {{`${gabinete.label}`}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div
              class="block"
              style="
                display: flex;
                align-items: center;
                margin-top: 16px;
              "
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="Imprimir Agenda Actual"
                placement="top-start"
              >
                <el-button
                  icon="el-icon-printer"
                  style="
                    background-color: #6a41bdca;
                    color: #ffffff;
                    border-radius: 5px;
                    font-size: 16px;
                  "
                  @click="modalprint = true;"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
          <div class="schedule">
            <div class="header">
              <div class="time">
                <i class="el-icon-time" />
              </div>
              <div class="inf">
                <i class="el-icon-user" />
              </div>
              <div class="cost" v-if="showSocial">
                <i class="el-icon-money" />
              </div>
              <div class="status">
                <i class="el-icon-user" />
              </div>
              <div class="comments">
                <i class="el-icon-document" />
              </div>
            </div>
            <!-- Inicio de la tabla  -->
            <div
              v-if="showSocial"
              class="appointmentsContainer infinite-list"
              style="overflow:auto; height: auto;"
            >
            <div
                v-for="(item, idx) in appointmentsShowing"
                :class="getClass(item.idcita)"
                :key="idx"
                :ref="ref"
            >
              <div class="infoAppointment" v-if="appointmentsShowing.length >= 1">
                <div class="horario" style="width: 14%;">
                  <div class="time">
                  <strong> {{ formatHour(item.time) }} </strong>
                    <div class="actions">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Realizar evaluación"
                        placement="top"
                        v-if="blockPermission(['FD', 'ADMIN'])
                        && specialPermission(item)"
                      >
                        <i
                          class="el-icon-edit"
                          @click="redirectToAction(idx)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Cancelar cita"
                        placement="top"
                        v-if="blockPermission(['OPTO', 'MD'])"
                      >
                        <i
                          class="el-icon-delete"
                          @click="handleCancel(idx)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Terminar cita"
                        placement="top"
                        v-if="blockPermission(['FD', 'ADMIN', 'OPTO'])
                        && specialPermission(item)"
                      >
                        <i
                          class="el-icon-document-checked"
                          @click="check(idx, item.idcita)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Re-agendar cita"
                        placement="top"
                        v-if="blockPermission(['OPTO'])"
                      >
                        <i
                          class="el-icon-date"
                          @click="openDateDialog(idx)"
                        />
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="medicalInfo" style=" width: 20%; text-align: center;" >
                  <label style="color: #6a41bdb4">
                    <strong style="font-size: 18px;">
                      <a @click='sendrowsValue(item)'>
                        {{ item.nombrePaciente }} {{item.apellidoPaciente}} - ({{ item.id }})
                      </a>
                    </strong>
                  </label><br>
                  <label> {{item.type}} </label><br>
                  <br>
                  <br>
                  <label><strong>{{ item.medico }} {{item.apellidoMedico}}</strong></label><br>
                  <label
                    v-if="item.subject !== 'Médico'"
                  >
                  <strong>{{item.especialidad.toUpperCase()}}</strong><br>
                  ({{item.procedure}})
                  </label>
                  <label v-if="item.subject === 'Médico'">
                  {{ item.subject }}
                  </label>
                </div>
                <div
                  class="infoCostAppointment"
                  style="text-align:center;width:25%;"
                >
                  <el-select
                    v-model="item.cost"
                    placeholder="Select"
                    @change="valueCost(item.idcita, idx)"
                    style="width: 195px;"
                  >
                    <el-option
                      v-for="elementos in cost"
                      :key="elementos.value"
                      :label="elementos.label"
                      :value="elementos.value"
                    />
                  </el-select>
                  <div
                    class="statusSection"
                    v-if="item.cost === 'sin costo'"
                    :style="{background: '#FF6600'}"
                  />
                  <div
                    class="statusSection"
                    v-if="item.cost === 'con costo'"
                    :style="{background: '#008F39'}"
                  />
                  <div
                    class="statusSection"
                    v-if="item.cost === 'costo no definido'"
                    :style="{background: '#5555', 'height' : '9px'}"
                  /><br>
                  <div
                      class="statusSection"
                      v-if="item.cost === 'costo no definido' ||
                      item.cost === 'con costo' ||
                      item.cost === 'sin costo'"
                    >
                    <label>
                    Costo asignado por
                    </label><br>
                    <strong>{{item.createdByCost}} {{item.createdByCostLastName}}</strong>
                  </div>
                  <div
                      v-if="item.cost === null"
                      style="margin-top: 10px"
                    >
                    <strong>
                      No definido
                    </strong><br>
                  </div>
                </div>
                <div
                  class="infoCostAppointment"
                  style="text-align: center; marging-left: 10px;width: 18%"
                >
                <div class="status">
                  <el-select
                    v-model="item.statusId"
                    placeholder="Estado"
                    @change="(e) => onStatusChange(e, item.id, idx)"
                    empty="Sin Espeficar"
                  >
                    <el-option
                      v-for="(option, optIdx) in statusOptions"
                      :key="`${option}-${optIdx}`"
                      :label="option.status"
                      :value="option.id"
                    >
                      <span
                        style="
                          height: 100%;
                          width: 5px;
                          position: absolute;
                          left: 0px;
                        "
                        :style="{ 'background-color': option.colorCode }"
                      />
                      <span>{{ option.status }}</span>
                    </el-option>
                  </el-select>
                  <!-- <h1>{{appointmentsShowing[idx].idcita}}</h1> -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.colorCode"
                    placement="top"
                  >
                    <div
                      :style="{
                        'background-color': item.colorCode || '#f0f0f0',
                        'height':'9px',
                      }"
                    />
                  </el-tooltip>
                </div>
              </div>
              <div style=" width: 20%;">
                <div style="text-align: right;">
                  <el-button
                    icon="el-icon-edit"
                    v-if="!isFormEnabled(idx)"
                      @click="enableForm(idx)"
                    size="mini"
                    circle
                  />
                </div>
                  <div v-if="isFormEnabled(idx)">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Please input"
                      v-model="item.comments"
                    />
                    <div
                      class="btn-options-comments"
                      style="text-align: right; margin-top: 7px;"
                      v-if="isFormEnabled(idx)"
                    >
                      <el-button
                        type="success"
                        icon="el-icon-plus"
                        v-if="isFormEnabled(idx)"
                        @click="submitEditComment(item)"
                        circle
                        size="mini"
                      />
                      <el-button
                        type="danger"
                        icon="el-icon-close"
                        v-if="isFormEnabled(idx)"
                        @click="closeForm"
                        circle
                        size="mini"
                      />
                    </div>
                  </div>
                  <div v-if="!isFormEnabled(idx)">
                    {{item.comments}}
                  </div>
                </div>
              </div>
              <el-divider style="color: #fff"/>
            </div>
            <div class="sinDatos" v-if="appointmentsShowing.length <= 0">
              <div class="contentSinDatos">
                <label>Sin datos</label>
              </div>
            </div>
            </div>
            <!-- Inicio de la tabla TS -->
            <div
              v-if="!showSocial"
              class="appointmentsContainer infinite-list"
              style="overflow:auto; height: auto;"
            >
            <div
                v-for="(item, idx) in appointmentTs"
                :class="getClassTS(item.idcita)"
                :key="idx"
                :ref="ref"
            >
              <div class="infoAppointment">
                <div class="horario" style="width: 33.3%;">
                  <div class="time">
                  <strong> {{ formatHour(item.time) }} </strong>
                    <div class="actions">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Realizar evaluación"
                        placement="top"
                        v-if="blockPermission(['FD', 'ADMIN'])
                        && specialPermission(item)"
                      >
                        <i
                          class="el-icon-edit"
                          @click="redirectToActionTS(idx)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Cancelar cita"
                        placement="top"
                        v-if="blockPermission(['OPTO'])"
                      >
                        <i
                          class="el-icon-delete"
                          @click="handleCancel(idx)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Terminar cita"
                        placement="top"
                        v-if="blockPermission(['FD', 'ADMIN', 'OPTO'])
                        && specialPermission(item)"
                      >
                        <i
                          class="el-icon-document-checked"
                          @click="checkTS(idx, item.idcita)"
                        />
                      </el-tooltip>
                      <!-- <el-tooltip
                        class="item"
                        effect="dark"
                        content="Re-agendar cita"
                        placement="top"
                        v-if="blockPermission(['OPTO'])"
                      >
                        <i
                          class="el-icon-date"
                          @click="openDateDialogTS(idx)"
                        />
                      </el-tooltip> -->
                    </div>
                  </div>
                </div>
                <div
                  class="medicalInfo"
                  style=" width: 33.3%; text-align: center;"
                >
                  <label style="color: #6a41bdb4">
                    <strong style="font-size: 18px;">
                      {{ item.nombrePaciente }} {{item.apellidoPaciente}} - ({{ item.id }})
                    </strong>
                  </label><br>
                  <label> {{item.type}} </label><br>
                  <br>
                  <br>
                  <label>
                    <strong>{{ item.trabajadorSocial }} {{item.apellidoTS}}</strong>
                  </label><br>
                </div>
                <!-- <div
                  class="infoCostAppointment"
                  style="text-align: center; width: 25%;"
                >
                  <label><strong  style="color: #6a41bdb4;">Estado de Costo</strong></label>
                  <br>
                  <el-select
                    v-model="item.cost"
                    placeholder="Select"
                    @change="valueCost(item.idcita)"
                    style="width: 195px;"
                  >
                    <el-option
                      v-for="elementos in cost"
                      :key="elementos.value"
                      :label="elementos.label"
                      :value="elementos.value"
                    />
                  </el-select>
                  <div
                    class="statusSection"
                    v-if="item.cost === 'sin costo'"
                    :style="{background: '#FF6600'}"
                  />
                  <div
                    class="statusSection"
                    v-if="item.cost === 'con costo'"
                    :style="{background: '#008F39'}"
                  />
                  <div
                    class="statusSection"
                    v-if="item.cost === 'costo no definido'"
                    :style="{background: '#5555'}"
                  /><br>
                  <label>Costo asignado por </label><br>
                  <strong>{{item.createdByCost}} {{item.createdByCostLastName}}</strong>
                </div> -->
                <div
                  class="infoCostAppointment"
                  style="text-align: center; marging-left: 10px;width: 30%"
                >
                <div class="comments" style=" width: 100%;">
                  <div style="text-align: right;">
                    <el-button
                      icon="el-icon-edit"
                      v-if="!isFormEnabled(idx)"
                       @click="enableForm(idx)"
                      size="mini"
                      circle
                    />
                  </div>
                    <div v-if="isFormEnabled(idx)">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="Please input"
                        v-model="item.comments"
                      />
                      <div
                        class="btn-options-comments"
                        style="text-align: left; margin-bottom: 7px; margin-top: 10px;"
                        v-if="isFormEnabled(idx)"
                      >
                        <el-button
                          type="success"
                          icon="el-icon-plus"
                          v-if="isFormEnabled(idx)"
                          @click="submitEditCommentTS(item)"
                          circle
                          size="mini"
                        />
                        <el-button
                          type="danger"
                          icon="el-icon-close"
                          v-if="isFormEnabled(idx)"
                          @click="closeForm"
                          circle
                          size="mini"
                        />
                      </div>
                    </div>
                    <div v-if="!isFormEnabled(idx)">
                      {{item.comments}}
                    </div>
                  </div>
                </div>
              </div>
              <el-divider style="color: #fff"/>
            </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="calendarArea">
        <div class="calendar">
          <div class="title">
            <p
              style="
                font-weight: bold;
                font-size: 18px;
                color: #6a41bdb4;
                "
            >
              SELECCIONE LA FECHA DESEADA
            </p>
          </div>
          <datepicker
            v-model="selectedDate"
            :language="languages[language]"
            :inline="true"
            :highlighted="highlighted"
            @changedMonth="changedMonth"
          />
          <!-- <div class="stadistics">
            <div class="section">
              <div class="info">
                <p class="label">Citas del día</p>
                <p class="number">{{ dailyAppointments.total || 0 }}</p>
                <p class="content">
                  {{ dailyAppointments.canceled || 0 }} cita(s) ha(n) sido cancelada(s)
                </p>
              </div>
              <div class="icon">
                <i class="el-icon-date"/>
              </div>
            </div>
            <div class="section">
              <div class="info">
                <p class="label">Pacientes nuevos del mes</p>
                <p class="number">{{ monthlyPatients.reduce((a, b) => a + b.total, 0) }}</p>
                <p class="content">
                  <span
                    v-for="(item, idx) in monthlyPatients"
                    :key="idx.toString()"
                  >
                    {{ `${item.total} ${item.gender}` }}
                    {{ `${(monthlyPatients.length > idx + 1 ? ',' : '.')}` }}
                  </span>
                </p>
              </div>
              <div class="icon">
                <i class="el-icon-folder-add"/>
              </div>
            </div>
          </div> -->
          <div class="bloquearAgenda">
            <router-link :to='`/admin/appointments/old`'>
              <el-button >Ir a angenda anterior</el-button>
            </router-link>
            <!-- <el-button
              v-if="blockPermission(['MD','OPTO','TS'])"
              @click="dialog = true;"
            >
              Bloqueo de Agendas
            </el-button>
            <el-drawer
              title="Bloqueo de Agenda"
              :before-close="handleClose"
              :visible.sync="dialog"
              direction="ltr"
              custom-class="demo-drawer"
              ref="drawer"
              >
              <div
                class="demo-drawer__content"
                style="display: flex; align-items: center; flex-direction: column;"
              >
                <el-select v-model="medico" placeholder="Select">
                  <el-option
                    v-for="item in medicos"
                    :key="item.id"
                    :label="item.firstName"
                    :value="item.id"
                  />
                </el-select>
                <div class="block">
                  <h4>Fechas</h4>
                  <el-date-picker
                    v-model="value1"
                    type="daterange"
                    range-separator="al"
                    start-placeholder="Fecha Inicio"
                    end-placeholder="Fecha Final"
                  />
                </div>
                <div
                  class="demo-drawer__footer"
                  style="display: flex; flex-direction: row; margin-top: 15px"
                >
                  <el-button @click="cancelForm">Cancel</el-button>
                  <el-button
                    @click="$refs.drawer.closeDrawer()" :loading="loading">
                    {{ loading ? 'Insertando ...' : 'Aceptar' }}
                  </el-button>
                </div>
              </div>
            </el-drawer> -->
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="Confirmación de cancelación"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form
        :model="form"
        ref="form"
        @submit.prevent
      >
        <el-form-item label="Motivo" prop="reason">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="255"
            v-model="form.reason"
          />
        </el-form-item>
        <el-form-item style="display: flex; flex-direction: row; justify-content: flex-end">
          <el-button
            type="danger"
            @click="beforeSubmit">
              Cancelar cita
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Re-agendar"
      :visible.sync="dateDialog"
      width="20%"
      v-loading="dateDialogLoading"
    >
    <div>
      <div class="calendario">
        <h4> Subsecuente {{subjectPunter}} </h4>
        <Calendar
          v-if="subjectPunter === 'social'"
          v-on:selected-hour="dateDialogOnSelectHour"
          v-on:selected-date="dateDialogOnSelectDate"
          :selectedDateDefault="dateDialogDefault"
          :disableds="dateDialogReserved"
        />
        <Calendar
          v-if="subjectPunter === 'Especialidad'"
          v-on:selected-hour="dateDialogOnSelectHour"
          v-on:selected-date="dateDialogOnSelectDate"
          :disabledsEspeciality="reservedHoursProcedure"
        />
        <Calendar
          v-if="subjectPunter === 'Médico'"
          v-on:selected-hour="dateDialogOnSelectHour"
          v-on:selected-date="dateDialogOnSelectDate"
          :disableds="dateDialogReserved"
        />
      </div>
      <h4>{{dateDialogReserved}}</h4>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dateDialog = false">Cancelar</el-button>
        <el-button type="primary" @click="dateDialog = true">Reagendar</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="modalprintSocial"
      width="35%"
    >
      <PrintPdf :citas="appointmentTs" :appointmentDate="selectedDateStr"/>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="modalprintSocial = false"
          style="background-color: #6a41bdca; color: #fff; border-radius: 10px"
        >
          Cancelar
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="modalprint"
      width="35%"
    >
      <PrintPdf :citas="appointmentsShowing" :appointmentDate="selectedDateStr"/>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="modalprint = false"
          style="background-color: #6a41bdca; color: #fff; border-radius: 10px"
        >
          Cancelar
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="main-popup"
      :visible.sync="dialogPatientVisible"
      width="80%"
      :close-on-press-escape="false"
    >
      <dialogPatientList :rowsValue="currentRow"/>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import Calendar from '../../components/Calendar';
import PrintPdf from '../../components/pdfAgendas/visualPDF';
import dialogPatientList from '../../components/dialogPatientList';

const moment = require('moment');

export default {
  data() {
    return {
      subjectPunter: null,
      dialogPatientVisible: false,
      currentRow: [],
      valuePrimeraVez: null,
      valueSubsecuente: null,
      modalprint: false,
      modalprintSocial: false,
      showSocial: true,
      citaComprobador: null,
      comments: null,
      newComment: null,
      switchComment: false,
      departamento: [
        {
          label: 'Recepción',
          value: 1,
          colorCode: '#0097e6',
        },
        {
          label: 'Optometría',
          value: 2,
          colorCode: '#8c7ae6',
        },
        {
          label: 'Médico',
          value: 3,
          colorCode: '#ff7675',
        },
        {
          label: 'Médico Pasante',
          value: 4,
          colorCode: '#4cd137',
        },
        {
          label: 'Trabajo Social',
          value: 5,
          colorCode: '#227093',
        },
      ],
      citaTipo: 'Médico',
      appointmentBase: [],
      valuemostrarTodo: null,
      valuePrimera: null,
      valueEspecialidades: null,
      valueOperatoria: null,
      valueGabinete: null,
      valueUrgencia: null,
      medicos: [],
      trabajadorSocial: null,
      trabajadoresSociales: [],
      medico: null,
      cost:
        [
          {
            id: 1,
            value: 'sin costo',
            label: 'sin costo',
          },
          {
            id: 2,
            value: 'con costo',
            label: 'con costo',
          },
          {
            id: 3,
            value: 'costo no definido',
            label: 'costo no definido',
          },
        ],
      mostrarTodo: [
        {
          value: 'mostrarTodo',
          label: 'Mostrar Todo',
        },
      ],
      especialidades: [],
      opciones: [
        {
          value: 'Mostrar Todo',
          label: 'Mostrar Todo',
        },
        {
          value: 'especialidades',
          label: 'Especialidades',
          children: [
            {
              value: 'Mostrar Todo',
              label: 'Mostrar Todo',
            },
          ],
        },
        {
          value: 'medicos',
          label: 'Consulta General',
        },
      ],
      gabinete: [],
      gabineteProcedimientos: [],
      primeraVez: [
        {
          value: 'medicos',
          label: 'Médicos',
          children: [
            {
              value: 'Mostrar Todo',
              label: 'Mostrar Todo',
            },
          ],
        },
      ],
      form: {
        reason: null,
      },
      formEnabled: null,
      commentFormLoading: false,
      commentForm: {
        comment: '',
      },
      commentFormRules: {
        comment: [],
      },
      rules: {
        reason: [
          {
            required: true,
            message: 'Campo requerido',
          },
        ],
      },
      showMDAppointments: false,
      dateDialog: false,
      dateDialogDateSelected: '',
      dateDialogTimeSelected: '',
      dateDialogReserved: [],
      reservedHoursProcedure: [],
      dateDialogDefault: '',
      dateDialogAppointmentIdx: null,
      dateDialogLoading: false,
      dialogVisible: false,
      currentSelectedUserId: null,
      filterTextPrimera: 'Seleccionar',
      filterText: 'Seleccionar',
      filterTextEsp: 'Seleccionar',
      filterTextGab: 'Seleccionar',
      appointmentTs: [],
      users: [],
      appointmentsShowing: [],
      languages: lang,
      language: 'es',
      selectedDate: null,
      selectedDateStr: null,
      dateAppointments: 15,
      canceled: 1,
      highlighted: {
        daysOfMonth: [],
      },
      pagination: -1,
      currentPage: 1,
      loadingTable: false,
      newPatientsOfMonth: 21,
      male: 9,
      female: 12,
      ref: 0,
      appointments: [],
      loading: false,
      table: false,
      dialog: false,
      especialidadesNombre: [],
      loadingService: null,
      monthlyPatients: [],
      dailyAppointments: {},
      statusOptions: [],
      formDrawer: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '80px',
      timer: null,
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      value1: '',
      value2: '',
      haveGeneralProfile: null,
    };
  },
  components: {
    Datepicker,
    Calendar,
    PrintPdf,
    dialogPatientList,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    role() {
      return this.user.roleId;
    },
    // // infiniteScrollDisabled() {
    // //   return this.page >= this.pagination || this.loadingTable;
    // // },
  },
  methods: {
    sendrowsValue(item) {
      this.dialogPatientVisible = true;
      this.currentRow = item;
    },
    assingDataofAllAppointments() {
      const opcionesEsp = this.opciones[1].children;
      const opcionesMed = this.opciones[2].children;

      const primeraMed = this.primeraVez[0].children;
      for (let i = 0; i < this.especialidades.length; i++) {
        opcionesEsp.push(this.especialidades[i]);
      }
      for (let i = 0; i < this.users.length; i++) {
        opcionesMed.push({
          label: `${this.users[i].firstName} ${this.users[i].lastName}`,
          value: `${this.users[i].id}`,
        });
        primeraMed.push({
          label: `${this.users[i].firstName} ${this.users[i].lastName}`,
          value: `${this.users[i].id}`,
        });
      }
    },
    async changeSocial() {
      if (this.showSocial) {
        await this.getEspecialidades();
        this.getDataSubsecuente(this.selectedDateStr);
        this.assingDataofAllAppointments();
        this.getGabineteProcedimientos();
      } else {
        this.citaComprobador = 'social';
        await this.getDataTs(this.selectedDateStr);
        await this.getTs();
      }
    },
    handleClose(done) {
      if (this.loading) {
        return;
      }
      this.$confirm('Do you want to submit?')
        .then(() => {
          this.loading = true;
          this.timer = setTimeout(() => {
            done();
            // animation takes time
            setTimeout(() => {
              this.loading = false;
            }, 400);
          }, 2000);
        })
        .catch(() => {});
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    async valueCost(idcitalocal) {
      try {
        const paciente = this.appointment.find((element) => element.idcita === idcitalocal);
        const costo = paciente.cost;
        const request = await this.axios.put(`/patient/subsecuente/updatecost/${idcitalocal}`, {
          idcita: idcitalocal,
          cost: costo,
        });
        // await this.onStatusChange(paciente.EstadoPacienteId, paciente.id, idx);
        if (request) {
          this.$notify({
            type: 'success',
            message: 'Costo actualizado con éxito',
          });
        }
      } catch (err) {
        this.$errorNotify(err);
      }
    },
    async valueStatus(idStatus, idStatusItem) {
      try {
        const request = await this.axios.put('/patient/subsecuente/updatestatus', {
          statusId: idStatus,
          id: idStatusItem,
        });
        if (request) {
          this.$notify({
            type: 'success',
            message: 'Status actualizado con éxito',
          });
        }
      } catch (err) {
        this.$errorNotify(err);
      }
    },
    enableForm(idx) {
      if (!this.formEnabled) {
        this.formEnabled = idx;
        const item = this.appointment[idx];
        this.commentForm.comment = item.comments;
      } else {
        this.$confirm('Tiene una edición de comentario activa. ¿Desea cancelarlo y continuar?', 'Alerta', {
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(() => {
          this.closeForm();
          this.enableForm(idx);
        });
      }
    },
    isFormEnabled(idx) {
      return this.formEnabled === idx;
    },
    hasPermission(section) {
      const id = this.roleID;
      if (id === 'ADMIN') {
        return true;
      }
      if (id === section) {
        return true;
      }
      return false;
    },
    hasFormPermission(item) {
      const isSocialAppointment = item.user.role.id === 'TS';
      const socialRoles = [
        'TS',
        'FD',
        'ADMIN',
      ];
      const mdRoles = socialRoles.concat(['MD']);
      return (isSocialAppointment && socialRoles.includes(this.role))
        || (!isSocialAppointment && mdRoles.includes(this.role));
    },
    closeForm() {
      this.formEnabled = null;
      // this.commentForm.comment = '';
    },
    async submitEditComment(item) {
      if (item) {
        try {
          const { idcita } = item;
          const { comments } = item;
          const request = await this.axios.put(`/patient/subsecuente/updatecomment/${idcita}`, {
            comment: comments,
          });
          if (request.status === 200) {
            this.$notify({
              type: 'success',
              message: 'Comentario actualizado con éxito',
            });
            this.closeForm();
          }
        } catch (error) {
          this.$errorNotify(error);
        } finally {
          this.commentFormLoading = false;
        }
      }
    },
    async submitEditCommentTS(item) {
      if (item) {
        try {
          const { idcita } = item;
          const { comments } = item;
          const request = await this.axios.put(`/patient/subsecuente/updatecommentTS/${idcita}`, {
            comment: comments,
          });
          if (request.status === 200) {
            this.$notify({
              type: 'success',
              message: 'Comentario actualizado con éxito',
            });
            this.closeForm();
          }
        } catch (error) {
          this.$errorNotify(error);
        } finally {
          this.commentFormLoading = false;
        }
      }
    },
    async onStatusChange(statusId, patientId, idx) {
      try {
        const appointmentId = this.appointmentsShowing[idx].idcita;
        const { status } = this.appointmentsShowing[idx];
        const statusObj = this.statusOptions.find((x) => x.id === statusId);
        let response = null;
        if (statusObj) {
          if (status === null) {
            response = await this.axios.post(`patient/status/${patientId}/${appointmentId}`, {
              statusId,
            });
          } else {
            response = await this.axios.put(`patient/status/${patientId}/${appointmentId}`, {
              statusId,
            });
          }
          const { data } = response;
          response = await this.axios.post(`patient/changelog/${patientId}`, {
            title: 'Semáforo',
            message: `Se ha actualizado el estado del paciente a "${statusObj.status}"`,
          });
          this.$notify({
            type: 'success',
            message: data.message,
          });
          this.appointmentsShowing[idx].colorCode = statusObj.colorCode;
          this.appointmentsShowing[idx].status = statusObj.status;
          this.appointmentsShowing[idx].statusId = statusObj.id;
        } else {
          if (status === null) {
            response = await this.axios.post(`patient/status/${patientId}/${appointmentId}`, {
              statusId: 1,
            });
          } else {
            response = await this.axios.put(`patient/status/${patientId}/${appointmentId}`, {
              statusId: 1,
            });
          }
          const { data } = response;
          const statusObj2 = await this.statusOptions.find((x) => x.id === data.statusId);
          this.appointmentsShowing[idx].colorCode = statusObj2.colorCode;
          this.appointmentsShowing[idx].status = statusObj2.status;
          this.appointmentsShowing[idx].statusId = statusObj2.id;
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    specialPermission(appointment) {
      return this.showMDAppointments
      && ['FD', 'TS'].includes(appointment.user.roleId)
        ? this.setPermission(['FD', 'TS']) : !this.showMDAppointments;
    },
    openDateDialog(idx) {
      this.dateDialogAppointmentIdx = idx;
      const appointment = this.appointmentsShowing[idx];
      const { subject } = appointment;
      this.subjectPunter = subject;
      this.dateDialogDefault = appointment.date;
      this.dateDialog = true;
    },
    openDateDialogTS(idx) {
      this.dateDialogAppointmentIdx = idx;
      const appointment = this.appointmentTs[idx];
      this.dateDialogDefault = appointment.date;
      this.dateDialog = true;
    },
    dateDialogOnSelectHour(val) {
      if (val) {
        this.dateDialogTimeSelected = val;
      }
    },
    async dateDialogOnSelectDate(val) {
      try {
        this.dateDialogLoading = true;
        if (val && val !== this.dateDialogDateSelected) {
          this.dateDialogDateSelected = val;
          const idx = this.dateDialogAppointmentIdx;
          if (this.citaTipo === 'social') {
            await this.getReservedHours(this.appointmentTs[idx].userId);
          } else if (this.citaTipo === 'Especialidad') {
            await this.getReservedHoursProcedure(
              this.appointmentsShowing[idx].especialidadId,
            );
          } else if (this.citaTipo === 'Médico') {
            await this.getReservedHours();
          }
        }
      } catch {
        // code
      } finally {
        this.dateDialogLoading = false;
      }
    },
    async getReservedHours() {
      try {
        this.loading = true;
        const response = await this.axios(`patient/subsecuente/md/reserved-schedules?date=${this.dateDialogDateSelected}`);
        const { data } = response;
        if (Array.isArray(data) && data.length > 0) {
          this.dateDialogReserved = data;
        }
        this.loading = false;
      } catch (error) {
        this.$errorNotify(error);
        this.loading = false;
      }
    },
    async getReservedHoursProcedure(idx) {
      try {
        this.dateDialogLoading = true;
        if (this.dateDialogDateSelected) {
          this.reservedHoursProcedure = [];
          const response = await this.axios(`patient/subsecuente/esp/reserved-schedules/${idx}?date=${this.dateDialogDateSelected}`);
          const { data } = response;
          // for (let index = 0; index < data.length; index++) {
          //   this.citaHora[index] = data[index].time;
          // }
          if (Array.isArray(data) && data.length > 0) {
            this.reservedHoursProcedure = data;
            const prereserved = [];
            for (let index = 0; index < data.length; index++) {
              const elemento = data[index].time;
              prereserved[elemento] = prereserved[elemento] ? prereserved[elemento] + 1 : 1;
            }
          }
        }
        this.loading = false;
      } catch (error) {
        this.$errorNotify(error);
        this.loading = false;
      }
    },
    async changeAppointmentDate() {
      try {
        const {
          dateDialogDateSelected: date,
          dateDialogTimeSelected: time,
          dateDialogAppointmentIdx: idx,
        } = this;
        const appointment = this.appointments[idx];
        this.dateDialogLoading = true;
        if (date && time) {
          let url = 'md';
          if (appointment.user.roleId === 'TS') {
            url = 'social';
          }
          const response = await this.axios.patch(`patient/appointment/${url}/reschedule/${appointment.id}`, {
            date,
            time,
          });
          if (response) {
            const { data } = response;
            let message = 'Se reagendo cita';
            if (url === 'social') {
              message += ' de trabajo social';
            }
            await this.axios.post(`patient/changelog/${appointment.patientId}`, {
              title: 'Agenda',
              message,
            });
            this.$notify({
              type: 'success',
              message: data.message,
            });
          }
          if (appointment.date !== date) {
            this.appointments.splice(idx, 1);
          } else {
            this.appointments[idx].time = time;
          }
          this.dateDialogDateSelected = '';
          this.dateDialogTimeSelected = '';
          this.dateDialogReserved = [];
          this.reservedHoursProcedure = [];
          this.dateDialogAppointmentIdx = null;
          this.dateDialogLoading = false;
          this.dateDialogDefault = '';
          this.dateDialog = false;
        } else {
          this.$message({
            type: 'error',
            message: 'Seleccione la fecha y hora correcta',
          });
        }
      } catch (error) {
        this.$errorNotify(error);
      } finally {
        this.dateDialogLoading = false;
      }
    },
    async handleCommandPrimeraVez(command) {
      try {
        this.citaComprobador = 'Médico';
        const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.citaTipo !== 'PRIMERA CITA') {
          this.citaTipo = 'PRIMERA CITA';
          await this.getData(date);
        }
        if (command === 'ALL') {
          await this.hightlights(date);
          this.appointmentsShowing = this.appointmentBase.filter((a) => a.type === 'PRIMERA CITA');
          this.currentSelectedUserId = null;
          this.filterTextPrimera = 'Mostrar Todo';
          this.filterText = 'Seleccionar';
          this.filterTextEsp = 'Seleccionar';
          this.filterTextGab = 'Seleccionar';
        } else {
          this.appointmentsShowing = this.appointmentBase.filter((a) => a.userId === command && a.type === 'PRIMERA CITA');
          this.currentSelectedUserId = command;
          const [user] = this.users.filter((x) => x.id === command);
          this.filterTextPrimera = `${user.firstName} ${user.lastName}`;
          this.filterText = 'Seleccionar';
          this.filterTextEsp = 'Seleccionar';
          this.filterTextGab = 'Seleccionar';
        }
      } catch (error) {
        // some code
      }
    },
    async handleCommand(command) {
      try {
        this.citaComprobador = 'Médico';
        const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.citaTipo !== 'Médico') {
          this.citaTipo = 'Médico';
          this.currentSelectedUserId = null;
          await this.getData(date);
          await this.hightlights(date);
        }
        if (command === 'ALL') {
          await this.hightlights(date);
          this.appointmentsShowing = this.appointmentBase;
          this.currentSelectedUserId = null;
          this.filterText = 'Mostrar Todo';
        } else {
          this.appointmentsShowing = this.appointmentBase.filter((a) => a.userId === command);
          this.currentSelectedUserId = command;
          const [user] = this.users.filter((x) => x.id === command);
          this.filterText = `${user.firstName} ${user.lastName}`;
        }
      } catch (error) {
        // some code
      }
      this.filterTextPrimera = 'Seleccionar';
      this.filterTextEsp = 'Seleccionar';
      this.filterTextGab = 'Seleccionar';
    },
    async handlerTs(item) {
      try {
        this.citaComprobador = 'social';
        const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.citaTipo !== 'social') {
          this.citaTipo = 'social';
          await this.getDataTs(this.selectedDateStr);
        }
        if (item === 'ALL') {
          this.appointmentTs = this.appointmentBase;
          this.currentSelectedUserId = null;
          this.filterTextPrimera = 'Seleccionar';
          this.filterText = 'Seleccionar';
          this.filterTextEsp = 'Seleccionar';
          this.filterTextGab = 'Seleccionar';
          await this.hightlights(date);
        } else {
          this.appointmentTs = this.appointmentBase.filter((a) => a.userId === item);
          this.currentSelectedUserId = item;
          this.filterTextPrimera = 'Seleccionar';
          this.filterText = 'Seleccionar';
          this.filterTextEsp = 'Seleccionar';
          this.filterTextGab = 'Seleccionar';
        }
      } catch (error) {
        // some code
      }
    },
    async handlerPrimeraVez(item) {
      this.citaComprobador = 'PRIMERA CITA';
      const param1 = item[0];
      const param2 = item[1];
      const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      if (this.citaTipo !== 'PRIMERA CITA') {
        this.citaTipo = 'PRIMERA CITA';
        this.currentSelectedUserId = null;
      }
      // SECCION DE MOSTRAR TODO
      if (param1 === 'Mostrar Todo') {
        this.citaTipo = 'Todo';
        await this.getAllDataAppointments(date);
        if (param2 === 'Mostrar Todo') {
          this.currentSelectedUserId = null;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA');
        }
      }
      // SECCION DE MEDICOS
      if (param1 === 'medicos') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'consultaGeneral';
        await this.getAllDataAppointmentConsultaGralPrimeraVez(date);
      }
      // SECCION DE ESPECIALIDADES
      if (param1 === 'especialidades') {
        this.citaTipo = 'Especialidad';
        await this.getDataSubsecuente(date);
        if (param2 === 'Mostrar Todo') {
          this.currentSelectedUserId = null;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.subject === 'Especialidad');
        } else {
          this.currentSelectedUserId = param2;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.especialidadId === this.currentSelectedUserId);
        }
      }
      this.valueSubsecuente = null;
      this.valueOperatoria = null;
      this.valueUrgencia = null;
      this.filterTextGab = 'Seleccionar';
      await this.hightlights(date);
    },
    async handleCommandEsp(item) {
      const param1 = item[0];
      const param2 = item[1];
      const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      if (this.citaComprobador !== 'Especialidad') {
        this.citaComprobador = 'Especialidad';
        this.currentSelectedUserId = null;
      }
      // SECCION DE MOSTRAR TODO
      if (param1 === 'Mostrar Todo') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'Todo';
        await this.getAllDataAppointments(date);
      }
      // SECCION DE MEDICOS
      if (param1 === 'medicos') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'consultaGeneral';
        await this.getAllDataAppointmentConsultaGral(date);
      }
      // SECCION DE ESPECIALIDADES
      if (param1 === 'especialidades') {
        this.citaTipo = 'Especialidad';
        await this.getDataSubsecuente(date);
        if (param2 === 'Mostrar Todo') {
          this.currentSelectedUserId = null;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE' && a.subject === 'Especialidad');
        } else {
          this.currentSelectedUserId = param2;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE' && a.especialidadId === this.currentSelectedUserId);
        }
      }
      await this.hightlights(date);
      this.valuePrimeraVez = null;
      this.valueOperatoria = null;
      this.valueUrgencia = null;
      this.filterTextGab = 'Seleccionar';
    },
    async handlerOperatoria(item) {
      const param1 = item[0];
      const param2 = item[1];
      const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      if (this.citaComprobador !== 'Operatoria') {
        this.citaComprobador = 'Operatoria';
        this.currentSelectedUserId = null;
      }
      // SECCION DE MOSTRAR TODO
      if (param1 === 'Mostrar Todo') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'Todo';
        await this.getAllDataAppointments(date);
      }
      // SECCION DE MEDICOS
      if (param1 === 'medicos') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'consultaGeneral';
        await this.getAllDataAppointmentConsultaGral(date);
        this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA');
      }
      // SECCION DE ESPECIALIDADES
      if (param1 === 'especialidades') {
        this.citaTipo = 'Especialidad';
        await this.getDataSubsecuente(date);
        if (param2 === 'Mostrar Todo') {
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.subject === 'Especialidad');
          this.currentSelectedUserId = null;
        } else {
          this.currentSelectedUserId = param2;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.especialidadId === this.currentSelectedUserId);
        }
      }
      this.valuePrimeraVez = null;
      this.valueSubsecuente = null;
      this.valueUrgencia = null;
      this.filterTextGab = 'Seleccionar';
      await this.hightlights(date);
    },
    async handleCommandGab(coman) {
      try {
        this.citaComprobador = 'Gabinete';
        const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.citaTipo !== 'Gabinete') {
          await this.getGabineteAppointment(date);
          this.citaTipo = 'Gabinete';
          this.currentSelectedUserId = null;
        }
        if (coman === 'ALL') {
          this.appointmentsShowing = this.gabinete;
          this.currentSelectedUserId = null;
          this.filterTextGab = 'Mostrar Todo';
          await this.hightlights(date);
        } else {
          this.currentSelectedUserId = coman;
          this.appointmentsShowing = this.gabinete.filter((a) => a.gabineteId === coman);
          const name = this.gabineteProcedimientos.filter((a) => a.value === coman);
          this.filterTextGab = name[0].label;
        }
        this.valuePrimeraVez = null;
        this.valueSubsecuente = null;
        this.valueOperatoria = null;
        this.valueUrgencia = null;
        this.filterTextGab = 'Seleccionar';
      } catch (error) {
        // some code
      }
    },
    async handlerEmergencia(item) {
      const param1 = item[0];
      const param2 = item[1];
      const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      if (this.citaComprobador !== 'EMERGENCIA') {
        this.citaComprobador = 'EMERGENCIA';
        this.currentSelectedUserId = null;
      }
      // SECCION DE MOSTRAR TODO
      if (param1 === 'Mostrar Todo') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'Todo';
        await this.getAllDataAppointments(date);
      }
      // SECCION DE MEDICOS
      if (param1 === 'medicos') {
        this.currentSelectedUserId = null;
        this.citaTipo = 'consultaGeneral';
        await this.getAllDataAppointmentConsultaGral(date);
      }
      // SECCION DE ESPECIALIDADES
      if (param1 === 'especialidades') {
        this.citaTipo = 'Especialidad';
        await this.getDataSubsecuente(date);
        if (param2 === 'Mostrar Todo') {
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.subject === 'Especialidad');
          this.currentSelectedUserId = null;
        } else {
          this.currentSelectedUserId = param2;
          this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.especialidadId === this.currentSelectedUserId);
        }
      }
      await this.hightlights(date);
    },
    async getStatistics(date) {
      try {
        const response = await this.axios.get(`patient/statistical/registered/monthly?date=${date}`);
        if (response) {
          const { data } = response;
          this.monthlyPatients = [...data];
        }
        const response2 = await this.axios.get(`patient/statistical/appointments/daily?date=${date}`);
        if (response2) {
          const { data } = response2;
          this.dailyAppointments = { ...data };
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    async getEspecialidades() {
      try {
        this.loading = true;
        const response = await this.axios.get('patient/subsecuente/especialidades/all');
        const { data } = response;
        if (Array.isArray(data)) {
          this.especialidades = data;
        }
        this.loading = false;
      } catch (error) {
        this.$errorNotify(error);
        this.loading = false;
      }
    },
    async getTs() {
      try {
        if (this.trabajadoresSociales.length === 0) {
          this.loading = true;
          const response = await this.axios.get('patient/subsecuente/usersSocial');
          const { data } = response;
          if (Array.isArray(data)) {
            this.trabajadoresSociales = data;
          }
          this.loading = false;
        }
      } catch (error) {
        this.$errorNotify(error);
        this.loading = false;
      }
    },
    setPermission(role) {
      if (Array.isArray(role)) {
        return role.includes(this.role);
      }
      return false;
    },
    blockPermission(role, force) {
      if (force) {
        return false;
      }
      if (Array.isArray(role)) {
        return !role.includes(this.role);
      }
      return false;
    },
    redirectToAction(index) {
      const { id } = this.appointmentsShowing[index];
      const { idcita } = this.appointmentsShowing[index];
      switch (this.user.role.id) {
        case 'OPTO':
          this.$router.push(`/admin/evaluations/opto/${id}`);
          break;
        case 'MD':
          this.$router.push(`/admin/evaluations/ofta/${id}/${idcita}`);
          break;
        case 'TS':
          this.$router.push(`/admin/evaluations/socialeva/${id}`);
          break;
        default:
          break;
      }
    },
    redirectToActionTS(index) {
      const { id } = this.appointmentTs[index];
      switch (this.user.role.id) {
        case 'OPTO':
          this.$router.push(`/admin/evaluations/opto/${id}`);
          break;
        case 'MD':
          this.$router.push(`/admin/evaluations/ofta/${id}`);
          break;
        case 'TS':
          this.$router.push(`/admin/evaluations/socialeva/${id}`);
          break;
        default:
          break;
      }
    },
    beforeSubmit() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          await this.cancel(this.currentAppointmentId);
          this.dialogVisible = false;
          this.currentAppointmentId = null;
        }
      });
    },
    handleCancel(id) {
      this.dialogVisible = true;
      this.currentAppointmentId = id;
    },
    async cancel(idx) {
      try {
        this.loading = true;
        // let url = '';
        // switch (this.role) {
        //   case 'MD':
        //     url = 'md';
        //     break;
        //   case 'OPTO':
        //     url = 'opto';
        //     break;
        //   case 'TS':
        //     url = 'social';
        //     break;
        //   default:
        // }
        const { idcita } = this.appointmentsShowing[idx];
        const cancelString = this.form.reason;
        const request = await this.axios.patch(`patient/subsecuente/md/cancel/${idcita}`, {
          cancelReason: cancelString,
        });
        if (request.status === 200) {
          this.appointmentsShowing.splice(idx, 1);
          this.$notify({
            type: 'success',
            message: 'Cancelación realizada con éxito',
          });
        }
        this.form.reason = null;
        this.loading = false;
      } catch (err) {
        this.$errorNotify(err);
      } finally {
        this.loading = false;
        this.form.reason = null;
      }
    },
    async check(idx, id) {
      try {
        this.loading = true;
        let url = '';
        switch (this.role) {
          case 'MD':
            url = 'md';
            break;
          case 'OPTO':
            url = 'opto';
            break;
          case 'TS':
            url = 'social';
            break;
          default:
            this.loading = false;
            return;
        }
        // const { id } = this.appointments[idx];
        const response = await this.axios.patch(`patient/appointment/${url}/check/${id}`);
        if (response.status === 200) {
          this.appointmentsShowing[idx].checked = true;
          // this.appointments[idx].checked = true;
          // this.ref++;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$errorNotify(err);
      }
    },
    async checkTS(idx, id) {
      try {
        this.loading = true;
        let url = '';
        switch (this.role) {
          case 'MD':
            url = 'md';
            break;
          case 'OPTO':
            url = 'opto';
            break;
          case 'TS':
            url = 'social';
            break;
          default:
            this.loading = false;
            return;
        }
        const response = await this.axios.patch(`patient/appointment/${url}/check/${id}`);
        if (response) {
          this.appointmentTs[idx].checked = true;
          this.ref++;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$errorNotify(err);
      }
    },
    getClass(id) {
      const index = this.appointmentsShowing.map((e) => e.idcita).indexOf(id);
      if (this.appointmentsShowing[index].checked) {
        return 'appointment checked';
      }
      if (this.appointmentsShowing[index].canceled) {
        return 'appointment canceled';
      }
      return 'appointment';
    },
    getClassTS(id) {
      const index = this.appointmentTs.map((e) => e.idcita).indexOf(id);
      if (this.appointmentTs[index].checked) {
        return 'appointment checked';
      }
      if (this.appointmentTs[index].canceled) {
        return 'appointment canceled';
      }
      return 'appointment';
    },
    async getAllDataAppointments(date) {
      try {
        this.loadingTable = true;
        let url = 'patient/subsecuente/getallAppointmentsPrimeraCita/';
        url = `${url}?date='${date}'`;
        const response = await this.axios(url);
        const { data } = response;
        if (data) {
          this.appointment = data;
          if (this.currentSelectedUserId) {
            if (this.citaComprobador === 'Especialidad') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'Operatoria') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'EMERGENCIA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'PRIMERA CITA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.especialidadId === this.currentSelectedUserId);
            }
          } else if (this.citaComprobador === 'Especialidad') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          } else if (this.citaComprobador === 'Operatoria') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA');
          } else if (this.citaComprobador === 'EMERGENCIA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA');
          } else if (this.citaComprobador === 'PRIMERA CITA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA');
          } else {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          }
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async getAllDataAppointmentConsultaGral(date) {
      try {
        this.loadingTable = true;
        let url = 'patient/subsecuente/getallCitaConsultaGeneral/';
        url = `${url}?date='${date}'`;
        const response = await this.axios(url);
        const { data } = response;
        if (data) {
          this.appointment = data;
          if (this.currentSelectedUserId) {
            if (this.citaComprobador === 'Especialidad') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'Operatoria') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'EMERGENCIA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'PRIMERA CITA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.especialidadId === this.currentSelectedUserId);
            }
          } else if (this.citaComprobador === 'Especialidad') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          } else if (this.citaComprobador === 'Operatoria') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA');
          } else if (this.citaComprobador === 'EMERGENCIA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA');
          } else if (this.citaComprobador === 'PRIMERA CITA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA');
          } else {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          }
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async getAllDataAppointmentConsultaGralPrimeraVez(date) {
      try {
        this.loadingTable = true;
        let url = 'patient/subsecuente/getallAppointmentsPrimeraCitaConsultaGeneral/';
        url = `${url}?date='${date}'`;
        const response = await this.axios(url);
        const { data } = response;
        if (data) {
          this.appointment = data;
          this.appointmentsShowing = data;
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async getData(date) {
      try {
        this.loadingTable = true;
        let url = 'patient/subsecuente/';
        switch (this.role) {
          case 'MD':
            url += 'fd';
            break;
          case 'OPTO':
            url += 'opto';
            break;
          case 'TS':
            // url += this.showMDAppointments ? 'FD' : 'social';
            url += 'md';
            break;
          case 'ADMIN':
            url += 'admin';
            break;
          case 'FD':
            url += 'FD';
            break;
          default:
            this.loadingTable = false;
            return;
        }
        url = `${url}?date='${date}'`;
        const response = await this.axios(url);
        const { data } = response;
        if (data) {
          this.appointment = data;
          this.appointmentBase = data;
          if (this.currentSelectedUserId) {
            if (this.citaTipo === 'Médico') {
              this.handleCommand(this.currentSelectedUserId);
            } else if (this.citaTipo === 'Operatoria') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.userId === this.currentSelectedUserId);
            } else if (this.citaTipo === 'PRIMERA CITA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.userId === this.currentSelectedUserId);
            } else if (this.citaTipo === 'Emergencia') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.userId === this.currentSelectedUserId);
            }
          } else if (this.citaTipo === 'Médico') {
            this.appointmentsShowing = this.appointment;
          } else if (this.citaTipo === 'Operativa') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA');
          } else if (this.citaTipo === 'PRIMERA CITA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA');
          } else if (this.citaTipo === 'Emergencia') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA');
          }
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async getDataSubsecuente(date) {
      try {
        this.loadingTable = true;
        let url = 'patient/subsecuente/esp/';
        switch (this.role) {
          case 'MD':
            url += 'md';
            break;
          case 'OPTO':
            url += 'opto';
            break;
          case 'TS':
            url += 'md';
            break;
          case 'ADMIN':
            url += 'admin';
            break;
          case 'FD':
            url += 'FD';
            break;
          default:
            this.loadingTable = false;
            return;
        }
        url = `${url}?date='${date}'`;
        const response = await this.axios(url);
        const { data } = response;
        if (data) {
          this.appointment = data;
          if (this.currentSelectedUserId) {
            if (this.citaComprobador === 'Especialidad') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'Operatoria') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'Emergencia') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA' && a.especialidadId === this.currentSelectedUserId);
            } else if (this.citaComprobador === 'PRIMERA CITA') {
              this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA' && a.especialidadId === this.currentSelectedUserId);
            }
          } else if (this.citaComprobador === 'Especialidad') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          } else if (this.citaComprobador === 'Operatoria') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'POST OPERATORIA');
          } else if (this.citaComprobador === 'Emergencia') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'EMERGENCIA');
          } else if (this.citaComprobador === 'PRIMERA CITA') {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'PRIMERA CITA');
          } else {
            this.appointmentsShowing = this.appointment.filter((a) => a.type === 'CITA SUBSECUENTE');
          }
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async getDataTs(date) {
      try {
        this.loadingTable = true;
        const response = await this.axios(`patient/subsecuente/social?date='${date}'`);
        if (response.data) {
          this.appointmentBase = response.data;
          if (this.currentSelectedUserId) {
            this.appointmentTs = this.appointmentBase.filter(
              (a) => a.userId === this.currentSelectedUserId,
            );
          } else {
            this.appointmentTs = this.appointmentBase;
          }
        }
        this.loadingTable = false;
      } catch (err) {
        this.$errorNotify(err);
        this.loadingTable = false;
      }
    },
    async load() {
      try {
        const date = moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.citaTipo === 'Médico') {
          await this.getData(date);
        } else if (this.citaTipo === 'Especialidad' || this.citaTipo === 'PRIMERA CITA') {
          await this.getDataSubsecuente(date);
        } else if (this.citaTipo === 'Gabinete') {
          await this.getGabineteAppointment(date);
        } else if (this.citaTipo === 'social') {
          await this.getDataTs(date);
        }
      } catch (err) {
        this.$errorNotify(err);
      }
    },
    formatHour(hour) {
      const FORMAT_TIME_INPUT = 'HH:mm';
      const FORMAT_TIME_OUTPUT = 'hh:mm A';
      return moment(hour, FORMAT_TIME_INPUT).format(FORMAT_TIME_OUTPUT);
    },
    async hightlights(date) {
      try {
        this.highlighted.daysOfMonth = [];
        const param = moment(date, 'YYYY-MM-DD').format('YYYY/MM');
        let response = [];
        if (this.citaComprobador === 'PRIMERA CITA') {
          if (this.citaTipo === 'Todo') {
            response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/hightlight/${param}`);
          } else if (this.citaTipo === 'consultaGeneral') {
            response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/consultaGeneral/hightlight/${param}`);
          } else if (this.citaTipo === 'Especialidad') {
            response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/esp/hightlight/${param}`);
          }
        } else if (this.citaComprobador === 'Operatoria' || this.citaComprobador === 'EMERGENCIA' || this.citaComprobador === 'Especialidad') {
          if (this.citaTipo === 'Todo') {
            response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/hightlight/${param}`);
          } else if (this.citaTipo === 'consultaGeneral') {
            response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/consultaGeneral/hightlight/${param}`);
          } else if (this.citaTipo === 'Especialidad') {
            if (this.currentSelectedUserId) {
              response = await this.axios.get(`patient/subsecuente/one/${this.citaComprobador}/${this.currentSelectedUserId}/hightlight/${param}`);
            } else {
              response = await this.axios.get(`patient/subsecuente/all/${this.citaComprobador}/esp/hightlight/${param}`);
            }
          }
        } else if (this.citaComprobador === 'Gabinete') {
          response = await this.axios.get(`patient/subsecuente/gabinete/all/hightlight/${param}`);
        } else if (this.citaComprobador === 'social') {
          response = await this.axios.get(`patient/subsecuente/social/hightlight/${param}`);
        } else if (this.citaComprobador === 'Todo') {
          response = await this.axios.get(`patient/subsecuente/all/hightlight/${param}`);
        }
        if (response.data) {
          this.highlighted.daysOfMonth = response.data;
        }
      } catch (error) {
        // some code
      }
    },
    async changedMonth(args) {
      const FORMAT = 'YYYY-MM-DD';
      let date = null;
      if (args.timestamp) {
        date = moment(new Date(args.timestamp)).format(FORMAT);
      } else {
        date = moment(args).format(FORMAT);
      }
      await this.hightlights(date);
    },
    async getStatuses() {
      try {
        this.loading = true;
        const response = await this.axios.get('patient/status/');
        const { data } = response;
        this.statusOptions = data;
      } catch (error) {
        this.$errorNotify(error);
      } finally {
        this.loading = false;
      }
    },
    async getGabineteProcedimientos() {
      try {
        const request = await this.axios.get('patient/subsecuente/gabinete/procedimientos');
        if (request.data) {
          this.gabineteProcedimientos = request.data;
        }
      } catch (error) {
        // console.error(error);
      }
    },
    async getGabineteAppointment(data) {
      try {
        this.loadingTable = true;
        this.citaTipo = 'Gabinete';
        const request = await this.axios.get(`patient/subsecuente/gabinete/?date=${data}`);
        if (request.data) {
          this.gabinete = request.data;
          if (this.currentSelectedUserId) {
            this.handleCommandGab(this.currentSelectedUserId);
          } else {
            this.appointmentsShowing = this.gabinete;
          }
        }
        this.loadingTable = true;
      } catch (error) {
        this.loadingTable = true;
        // console.error(error);
      }
    },
  },
  async created() {
    this.selectedDate = moment().format();
    // if (this.blockPermission(['TS', 'MD'])) {
    this.getStatuses();
    if (this.role === 'TS') {
      this.citaComprobador = 'social';
    } else if (this.role === 'OPTO' || this.role === 'MD' || this.role === 'FD') {
      this.citaComprobador = 'Todo';
    }
    await Promise.all([this.hightlights(this.selectedDate)]);
    const response = await this.axios.get('patient/appointment/users/MD');
    this.users = response.data;
    this.getTs();
    // const bandera = await this.getAllDataAppointments(this.selectedDate);
    // console.log(bandera);
    // await this.getDataTs(this.selectedDate);
    await this.getGabineteProcedimientos();
    await this.getEspecialidades();
    this.assingDataofAllAppointments();
  },
  watch: {
    loading(val) {
      if (val && !this.loadingService) {
        this.loadingService = this.$loading({
          fullscreen: true,
          lock: true,
          text: 'Cargando',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        setTimeout(() => {
          this.loadingService.close();
        }, 1000);
      }
    },
    async selectedDate(val) {
      if (val) {
        const date = moment(val, 'YYYY-MM-DD').format('YYYY-MM-DD');
        this.selectedDateStr = date;
        this.appointments = [];
        if (this.citaComprobador === 'PRIMERA CITA') {
          if (this.citaTipo === 'Todo') {
            await this.getAllDataAppointments(date);
          } else if (this.citaTipo === 'consultaGeneral') {
            await this.getAllDataAppointmentConsultaGralPrimeraVez(date);
          } else if (this.citaTipo === 'Especialidad') {
            await this.getDataSubsecuente(date);
          }
        } else if (this.citaComprobador === 'Operatoria' || this.citaComprobador === 'EMERGENCIA' || this.citaComprobador === 'Especialidad') {
          if (this.citaTipo === 'Todo') {
            await this.getAllDataAppointments(date);
          } else if (this.citaTipo === 'consultaGeneral') {
            await this.getAllDataAppointmentConsultaGral(date);
          } else if (this.citaTipo === 'Especialidad') {
            await this.getDataSubsecuente(date);
          }
        } else if (this.citaComprobador === 'Gabinete') {
          await this.getGabineteAppointment(date);
        } else if (this.citaComprobador === 'social') {
          await this.getDataTs(date);
        } else if (this.citaComprobador === 'Todo') {
          await this.getAllDataAppointments(date);
        }
        // this.getStatistics(date);
      }
    },
    async showMDAppointments(val) {
      if (val) {
        if (!this.users.length) {
          const response = await this.axios.get('patient/appointment/users/MD');
          this.users = response.data;
        }
      }
      const date = this.selectedDateStr;
      this.appointments = [];
      if (this.citaTipo === 'Médico') {
        await this.getData(date);
      } else if (this.citaTipo === 'Especialidad' || this.citaTipo === 'Operatoria' || this.citaTipo === 'Emergencia') {
        await this.getDataSubsecuente(date);
      } else if (this.citaTipo === 'Gabinete') {
        await this.getGabineteAppointment(date);
      } else if (this.citaTipo === 'social') {
        await this.getDataTs(date);
      }
      this.getStatistics(date);
    },
  },
};
</script>
<style lang="scss">
.el-dialog__body {
  padding: 5px 10px;
}
.el-input__inner .el-input.el-input--suffix{
  font-weight: 600;
  color: #6a41bdb4;
}
.el-cascader{
  font-weight: 600;
  color: #6a41bdb4;
}
.el-dropdown + .el-dropdown {
  margin-left: 10px;
}
.el-divider--vertical {
  width: 2px;
  height: 1.2em;
}
.el-divider {
  background-color: #6a41bdb4;
}
.container-Agenda{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
  margin-right: 10px;
  margin-bottom: 18px;
  color:#6a41bdb4;
  .containerInfo {
    display: flex;
    flex-direction: column;

    .titleContainer {
      height: 50px;
    }
    .dateContainer {
      height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 400px;
    }
  }

  .socialSwitch {
    display: flex;
    justify-content: right;
    align-items: center;
    margin: 8px 0px 10px 5px;
    .el-switch.is-checked .el-switch__core {
      border-color: #dddddd;
      background-color: #6a41bdb4;
    }
    .el-switch__label.is-active {
      color: #6a41bdb4;
    }
  }
}
.opcionesFiltradas{
  display: flex;
  width: 95%;
  flex-direction: column;
  .botones{
    display: flex;
    flex-direction: row;
    .block {
      display: flex;
      flex-direction: column;
      span{
        font-weight:600;
        color:#6a41bdb4;
      }
      margin-left: 18px;
      .el-cascader .el-input.el-input--suffix .el-input__inner {
        color:#6a41bdb4;
        font-weight:600;
      }
    }
  }
}
.appointmentsContainer {
  .el-divider {
    background-color: #b6d3ef;
  }
  .el-divider--horizontal {
    width: 90%;
    margin: 0 0 0 5%;
  }
}
.infoAppointment {
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  height: auto;
  // border: solid #6a41bdd7;
  // margin-bottom: 2px;
  // border-width: medium;
  .horario {
    height: auto;
    .time {
      text-align: center;
    }
  }
}
.vdp-datepicker__calendar {
  padding: 5px;
}
.vdp-datepicker__calendar .cell.selected {
  background: #6a41bdd7 !important;
  color: #fff;
}
.vdp-datepicker__calendar .cell.highlighted {
    background: #c4a7ff !important;
    color: #fff;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled):hover {
  background: rgba(104, 85, 247, 0.25) !important;
  color: #fff;
  border: none;
}
.vdp-datepicker__calendar {
  -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 0px 10px 2px rrgba(0, 0, 0, 0.19);
  box-shadow: 0px 0px 10px 2px rrgba(0, 0, 0, 0.19);
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: none !important;
}
.vdp-datepicker__calendar .cell.blank:hover {
  background: #ffffff !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover {
  border-radius: 50%;
}
.vdp-datepicker__calendar .cell.selected:hover {
  background: #006eff;
}
.vdp-datepicker__calendar .cell:hover {
  background: #006eff;
}
.el-dropdown-menu {
  // top: unset !important;
  overflow: auto !important;
  max-height: calc(100vh - 20px) !important;
}
.el-divider.el-divider--horizontal {
  background-color: #6A41BD;
}
</style>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
}
#appointments {
  height: 100%;
  .el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    .workingArea {
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .card {
        height: 100%;
        border-radius: 5px;
        background: #fff;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        .title {
          padding: 10px 25px;
          font-size: 20px;
          color: #557da6;
          font-weight: bold;
          align-self: flex-start;
        }
        .schedule {
          margin-top: 20px;
          min-height: 75%;
          width: 95%;
          .header {
            background-color: #6a41bdca;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0px 20px 0px 10px;
            align-items: center;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 5.3%;
            i {
              font-size: 32px;
              color: #ffffff;
            }
          }
          .appointmentsContainer {
            background-color: #fefefe;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            max-height: 90%;
            .appointment {
              background-color: #ffffff;
              .content {
                display: flex;
                flex-direction: row;
                .horario{
                  .time {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 13%;
                    color: #2e2a60;
                    background-color: #557da6;
                    font-weight: 600;
                    .actions {
                      i {
                        cursor: pointer;
                        color: #bfbfbf;
                      }
                    }
                  }
                }
                .info {
                  width: 45%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  .name {
                    color: #2e2a60;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.42px;
                    margin: 10px 0 2px;
                  }
                  .role {
                    color: #828bc2;
                    font-weight: normal;
                    font-size: 12px;
                    letter-spacing: 0.28px;
                    margin: 0 0 2px;
                    text-transform: uppercase;
                  }
                  .type {
                    color: #828bc2;
                    font-weight: normal;
                    font-size: 12px;
                    margin: -5px 0 10px 0 ;
                  }
                  .patient {
                    display: flex;
                    flex-direction: row;
                    color: #6a6a6a;
                    font-size: 12px;
                    line-height: 12px;
                    margin-bottom: 15px;
                    .name {
                      color: #6a6a6a;
                      font-size: 16px;
                      line-height: 12px;
                      margin: 0 0 0 2px;
                      border-bottom: 1px solid #FFF;
                      &:hover {
                        border-bottom: 1px solid #6A41BD;
                      }
                    }
                  }
                }
                .status {
                  width: 12%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  .color-code-badge {
                    background-color: #f0f0f0;
                    width: 100%;
                    height: 10px;
                    position: absolute;
                    bottom: 0px;
                  }
                }
                .cost {
                  width: 12%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  .color-code-badge {
                    background-color: #f0f0f0;
                    width: 100%;
                    height: 10px;
                    position: absolute;
                    bottom: 0px;
                  }
                }
                .comments {
                  width: 30%;
                  text-align: center;
                  display: block;
                  padding: 10px 0 10px 0;
                  position: relative;
                  .comments__actions {
                    position: absolute;
                    right: 10px;
                    .el-button {
                      padding: 5px !important;
                    }
                  }
                }
                .time,
                .location {
                  text-align: center;
                }
              }
            }
            .canceled {
              .content {
                background: #fcb7b7;
                display: flex;
                flex-direction: row;
                .time {
                  width: 20%;
                  color: #2e2a60;
                  font-weight: 600;
                  .actions {
                    display: none;
                  }
                }
                .info {
                  width: 50%;
                  .role {
                    color: #ffffff;
                  }
                  .patient {
                    color: #ffffff;
                  }
                }
                .location {
                  width: 30%;
                }
              }
            }
            .checked {
              background-color: #fbf1ff;
              .actions {
                display: none;
              }
            }
          }
        }
      }
    }
    .calendarArea {
      width: 25%;
      display: flex;
      flex-direction: column;
      height: 100vh;
      .calendar {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        height: 100%;
        .title {
          margin-top: 15px;
          color: #2e2a60;
        }
        .stadistics {
          .section {
            width: 300px;
            margin: 10px 0;
            border-radius: 5px;
            background: linear-gradient(180deg, #6a41bdd7 30%, #6A41BD 100%);
            padding: 10px;
            display: flex;
            flex-direction: row;
            .icon {
              i {
                color: #ffffff;
                font-size: 50px;
                float: right;
              }
            }
            .info {
              flex: 1;
              p {
                margin: 0;
              }
              .label {
                font-size: 16px;
                font-weight: 400;
                color: #ffffff;
              }
              .number {
                font-size: 25px;
                font-weight: bold;
                color: #ffffff;
              }
              .content {
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
              }
            }
          }
          .section:nth-child(2) {
            background: linear-gradient(180deg, #6a41bdd7 30%, #6A41BD 100%);
          }
        }
      }
    }
  }
}
.bloquearAgenda{
  margin-top: 15px;
  width: 301px;
  .el-button {
    background: linear-gradient(180deg,#6a41bdd7 30%, #6A41BD 100%);
    color: #fff;
    width: 100%;
  }
}
.infoPatientAppointment {
  margin-bottom: 0px;
  height: 100%;
  .medicalInfo {
    height: auto;
  }
}
.statusSection {
  margin: auto;
  width: 195px;
  height: 9px;
}
.sinDatos {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;

  .contentSinDatos{
    font-size: 16px;
    color: #707070;
  }
}
</style>
<style lang="scss">
.cont{
  height: 100vh !important;
}
.el-table .warning-row {
  background: oldlace !important;
}
#main-popup {
  .el-dialog__wrapper {
    overflow: unset!important;
  }
  .el-dialog__body {
    word-break: break-word!important;
  }
  .el-dialog {
    margin-top: 120px!important;
    min-width: 850px!important;
  }
  .el-dialog__header {
    height: 0px!important;
    padding: 0px!important;
  }
  .el-dialog__body{
    margin-top: 0px!important;
    padding: 0px!important;
  }
}
.History {
  position: absolute;
  width: 60%;
  height: 100%;
  right: 0px;
  top: 0px;
}
.history {
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 15px;
  right: 15px;
  .img-cont {
    height: 100%;
    margin-left: 15px;
    img {
      width: 50px!important;
      cursor: pointer;
    }
  }
}
.el-tabs__nav {
  width: 100%!important;
  #tab-landing, #tab-0, #tab-1, #tab-2, #tab-3, #tab-4 {
    background-color: #F4FAFF!important;
  }
  #tab-landing,  #tab-0 {
    margin-left: 20px;
    background-color: #78499fdf!important;
  }
  #tab-5 {
    margin-right: 20px;
  }
  #tab-5, #tab-6, #tab-7, #tab-8 {
    padding: 5px;
    background-color: #f3f3f3!important;
    float: right!important;
  }
}
.el-tabs__header {
  width: 100%!important;
  background-color: transparent!important;
  position: absolute;
  top: -55px;
}
.el-tabs__item {
  background-color: #fff;
  height: 55px!important;
  margin: 0px 5px;
  padding: 0px 10px!important;
}
.icon-img {
  height: 52px!important;
  cursor: pointer;
}
.el-tabs {
  .is-active {
    height: 55px!important;
  }
}
.el-tabs--border-card {
  border: none!important;
}
.el-tabs__content {
 padding: 0px!important;
}
.info {
  p{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.row {
  display: flex;
  flex-direction: row;
  .right-container {
    background-color: #fff;
    width: 80%;
    height: 100%;
    ::-webkit-scrollbar {
      width: 5px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background: #C2BEBF;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #B2AEAA;
    }
    .no-data {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 400px;
    }
    .right-content {
      width: 100%;
      max-height: 524px;
      overflow-y: scroll;
      overflow-x: hidden;
      margin: 0px;
      .title {
        margin: 0px;
        margin-top: 10px;
        font-weight: bold;
        color: #000;
      }
      .content {
        margin-top: 2px;
        margin: 0px;
        color: #808C95;
      }
    }
  }
}
.center {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  p {
    margin-bottom: 0px!important;
  }
  .img-container {
    img {
      width: 100px!important;
      height: 100px!important;
      border-radius: 50%;
      object-fit: contain;
    }
  }
}
.cont {
    height: 100%;
  .el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    .el-col {
      height: 95%;
      width:95%;
      display: flex;
      flex-direction: column;
      .search-container {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        width: 50%;
        .el-input {
          width: 60%;
          max-width: 60%;
          float: left!important;
          margin-right: 10px;
        }
      }
      .card {
        height: 90%;
        border-radius: 5px;
        background: #fff;
        padding: 0px;
        .title {
          margin: 5px 0px 0px 10px;
          font-size: 15px;
          color: #557DA6;
          font-weight: bold;
        }
        .el-table td {
          padding: 8px 0px;
        }
        .el-table {
          width: 100%;
          font-size: 11px;
          color: #646D82;
          margin-bottom: 5px;
          padding-left: 5px;
          .bold {
            font-weight: bold;
            color: #000;
          }
          .normal {
            color: #646D82;
          }
          ::-webkit-scrollbar {
            width: 5px;
            height: 5px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 5px;
          }
          ::-webkit-scrollbar-thumb {
            background: #C2BEBF;
            border-radius: 5px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background: #B2AEAA;
          }
        }
      }
    }
  }
}
</style>
